// extracted by mini-css-extract-plugin
export default {"root":"BurgerButton_root__pNQSQ","rootActive":"BurgerButton_rootActive__-Ir3v","line":"BurgerButton_line__kskCJ","lineHidden":"BurgerButton_lineHidden__wEEdX"};